// extracted by mini-css-extract-plugin
export default {"sizes":"'../../style/display.css'","mobile":"540px","laptop":"1200px","panel":"style_panel__KvJKW","inputsRow":"style_inputsRow__qUUy4","inputPair":"style_inputPair__sVSHg"};